import { css } from "@emotion/react";

export const styles = {
  inputBase: css`
    .bp4-input {
      font-family: var(--font-family-body);
      font-size: var(--font-size-body);
      border: var(--input-border-width, 1px) solid var(--color-border-primary);
      border-radius: var(--border-radii-base);
      box-shadow: none;
      -webkit-box-shadow: none;
      &:focus-within {
        border-color: var(--color-splash-primary);
      }
    }
  `,
  disabled: css`
    .bp4-input {
      background-color: var(--color-background-tertiary);
      box-shadow: none;
      color: var(--color-tertiary);
      cursor: not-allowed;
    }
  `,
  withError: css`
    .bp4-input {
      border-color: var(--color-danger);
      &:focus-within {
        border-color: var(--color-danger);
      }
    }
  `
};
